module.exports = __webpack_public_path__ + "img/Yak.d6beaf3f.png";